module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/filetypes-image-98883871d015a6419c65bd3d33a19869.svg";